import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {makeStyles} from '@material-ui/core/styles';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import {Button, FormControlLabel, IconButton, InputAdornment, TextField} from '@material-ui/core';
import {GreenCheckbox} from '../../../components/FlowConfigurationInputs';
import {useRecoilActions} from '../../../recoil-store/recoil-actions';
import {useQuery} from '../../../home/pages/variants/Variants';
import './LoginPage.css';

export const useStyles = makeStyles(theme => ({
    text: {
        borderRadius: 2,
        '& .MuiInputBase-input': {
            fontSize: 12,
            padding: '10px 20px'
        }
    },
    checkbox: {padding: 0}
}));
/**
 * @Description This function lets you return Login page.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
const LoginPage = () => {

    const {t} = useTranslation();
    const label = 'CONTENT.AUTH-PAGES.';
    const classes = useStyles();

    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const actions = useRecoilActions();
    const query = useQuery();

    useEffect(() => {
        const hostname = window.location.hostname
        if (hostname === "demo.autommate.app") {
            handleAdminLogin()
        }
    }, []);

    const handleUserLogin = async (e) => {
        setLoading(true);
        e.preventDefault();
        await actions.login({
            login_name: e.target.login_name.value,
            user_password: e.target.user_password.value
        }, query.get('to'));
        setLoading(false);
    };

    const handleAdminLogin = async () => {
        setLoading(true);
        await actions.login({login_name: 'administrator', user_password: 'Aa123456!'}, query.get('to'));
        setLoading(false);
    };

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="login-page">
            <form onSubmit={handleUserLogin} className="login-container">
                <div className="login-autommate"/>
                {/*<div className="login-buttons">*/}
                {/*    <Button variant="outlined" style={{padding: '10px 0', marginBottom: 15}} fullWidth disabled>*/}
                {/*        <span className="login-google"/>*/}
                {/*        <span className="login-continue">{t(label + 'USING-GOOGLE')}</span>*/}
                {/*    </Button>*/}
                {/*    <Button variant="outlined" style={{padding: '10px 0'}} fullWidth disabled>*/}
                {/*        <span className="login-github"/>*/}
                {/*        <span className="login-continue">{t(label + 'USING-GITHUB')}</span>*/}
                {/*    </Button>*/}
                {/*</div>*/}
                {/*<div className="login-seperator">*/}
                {/*    <div/>*/}
                {/*    <div>{t(label + 'USING-EMAIL')}</div>*/}
                {/*    <div/>*/}
                {/*</div>*/}
                <div>
                    <div className="login-label">
                        <div>{t(label + 'USERNAME')} *</div>
                        <TextField classes={{root: classes.text}} variant="outlined"
                                   fullWidth name="login_name" placeholder={t(label + 'USERNAME-PLACE')}/>
                    </div>
                    <div className="login-label">
                        <div>{t(label + 'PASSWORD')} *</div>
                        <TextField classes={{root: classes.text}} variant="outlined" name="user_password" fullWidth
                                   placeholder={t(label + 'PASSWORD-PLACE')} type={showPassword ? 'text' : 'password'}
                                   InputProps={{
                                       endAdornment:
                                           <InputAdornment position="end">
                                               <IconButton size="small" onClick={handleShowPassword}>
                                                   {showPassword ? <Visibility fontSize="inherit"/> :
                                                       <VisibilityOff fontSize="inherit"/>}
                                               </IconButton>
                                           </InputAdornment>
                                   }}/>
                    </div>
                    <div className="login-option">
                        <FormControlLabel control={<GreenCheckbox size="small"/>}
                                          label={<span className="login-remember">{t(label + 'REMEMBER')}</span>}/>
                        <Link to="/forgot-password">{t(label + 'FORGOT-PASSWORD')}</Link>
                    </div>
                </div>
                <div style={{width: "100%", display: "flex", justifyContent: "space-between"}}>
                    {/*<Button onClick={handleAdminLogin}*/}
                    {/*        style={{backgroundColor: '#031226', color: '#fff', width: 160, padding: '9px 0'}}>*/}
                    {/*    <span className="login-signin">{t(label + 'DEMO-LOGIN')}</span>*/}
                    {/*</Button>*/}
                    <Button disabled={loading} type="submit"
                            style={{backgroundColor: '#031226', color: '#fff', width: '100%', padding: '9px 0'}}>
                        <span className="login-signin">{t(label + 'SIGN-IN')}</span>
                    </Button>
                </div>
            </form>
            <div className="login-right">
                <div>{t(label + 'AUTOMATE')}</div>
                <div>{t(label + 'WITHOUT-CODE')}</div>
                <div>{t(label + 'INTEGRATING')}</div>
            </div>
        </div>
    );
};
export default LoginPage;
